import { useState, useEffect } from "react";
import {toFeetInches } from "../lib/Utils";
import { useTranslation } from "react-i18next";
import getSymbolFromCurrency from 'currency-symbol-map';

const LockerModalContent = ({
  lockerInfos,
  selectedDuration,
  onConfirm,
  onCancel,
  lockerCurrency
}) => {
  const { t } = useTranslation();
  const [selectedSlot, setSelectedSlot] = useState(null);

  //  Preselect slot based on global duration
  useEffect(() => {
    if (lockerInfos?.bookingSlots?.length > 0) {
      const defaultSlot =
        lockerInfos.bookingSlots.find(
          (slot) =>
            slot.durationInMilliseconds === selectedDuration
        ) || lockerInfos.bookingSlots[0];

      setSelectedSlot(defaultSlot);
    }
  }, [lockerInfos, selectedDuration]);

  const handleSlotChange = (slot) => {
    setSelectedSlot(slot);
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm({
        slot: selectedSlot,
        durationInMilliseconds:
          selectedSlot?.durationInMilliseconds,
      });
    }
  };

  const convertToInch = (w, d, h) => {
    if (!w || !d || !h) return "";
    return `${toFeetInches(w)} W x ${toFeetInches(d)} D x ${toFeetInches(h)} H`;
  };

  if (!lockerInfos) return null;

  return (
    <div className="modal-overlay">
      <div className="locker-modal">
        <h2 className="modal-title">{t("choose_locker_slot_title")}</h2>
        <div className="slot-list">
          {lockerInfos?.bookingSlots?.map((slot) => (
            <label
              key={slot.id}
              className={`slot ${
                selectedSlot?.id === slot.id ? "active" : ""
              }`}
            >
              <div className="left">
                <input
                  type="radio"
                  checked={selectedSlot?.id === slot.id}
                  onChange={() => handleSlotChange(slot)}
                />
                <span>{slot.durationRange}</span>
              </div>

              <div className="price">
               {`${getSymbolFromCurrency(lockerCurrency)} `} {slot.price}
              </div>
            </label>
          ))}
        </div>
        <div className="total-cost">
          <span>{t("total_label")}</span>
          <span> {`${getSymbolFromCurrency(lockerCurrency)} `} {selectedSlot?.price || 0}</span>
        </div>
        <div className="modal-actions">
          <button className="cancel-btn" onClick={onCancel}>
            {t("button_cancel")}
          </button>

          <button
            className="select-btn"
            onClick={handleConfirm}
            disabled={!selectedSlot}
          >
            {t("select_slot_button")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LockerModalContent;